import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../Assets/Images/Header/TikTok.svg";
import HeroTopVector from "../../Assets/Images/LandingPage/hero_top_vector.svg";
import HeroBottomVector from "../../Assets/Images/LandingPage/hero_bottom_vector.svg";


export const PageContainer = styled.div`
   font-family: 'Outfit', sans-serif;

  }

`;

